<template>
  <div class="row" v-if="exibir">
  </div>
</template>
<script>
  export default {
    name: "NextMusic",
    props:[],
    data(){
      return {
        exibir:false,
      }
    },
    mounted(){
    }
  }
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/PreviusMusic.vue